'use strict';

import lottie from 'lottie-web/build/player/lottie_light';

const $ = jQuery.noConflict();
$(function() {
	const heroContentAnimation = {

		init: function() {
			this.cacheDOM();
			if (!this.$animation.length) {
				return;
			}

			this.bindEvents();
		},

		cacheDOM: function() {
			this.$animation = $('.js-hero-content-animation');
		},

		bindEvents: function() {
			// the JSON files are several MB - fetch them only after the page (fonts, CSS, poster) has loaded
			if (document.readyState === 'complete') {
				this.playAnimation();
				return;
			}
			$(window).on('load', this.playAnimation.bind(this));
		},

		playAnimation: function() {
			this.$animation.each((index, wrapper) => {
				const $wrapper = $(wrapper);
				const path = $wrapper.data('animation-src');
				const container = $wrapper.find('.js-hero-content-lottie').get(0);

				if (!path || !container) {
					return;
				}

				const loop = $wrapper.data('animation-loop') === 1
					|| $wrapper.data('animation-loop') === '1';

				const animation = lottie.loadAnimation({
					container: container,
					renderer: 'svg',
					loop: loop,
					autoplay: true,
					path: path,
				});

				animation.addEventListener('DOMLoaded', () => {
					$wrapper.addClass('is-visible');
				});
			});
		},

	};

	heroContentAnimation.init();
});
